import {
  INITIAL_ZOOM,
  MOBILE_BREAKPOINT,
  MOBILE_INITIAL_ZOOM,
} from "../map/constants";

export function isMobileViewport(): boolean {
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
}

export function getGardenInitialZoom(): number {
  return isMobileViewport() ? MOBILE_INITIAL_ZOOM : INITIAL_ZOOM;
}

let visualViewportBound = false;
let onVisualViewportChange: (() => void) | null = null;

/** Sync --vh and --visual-bottom-inset from the visible viewport (Safari URL bar). */
export function syncVisualViewportInsets(): void {
  const vv = window.visualViewport;
  if (!vv) return;

  const bottomInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
  document.documentElement.style.setProperty("--vh", `${vv.height * 0.01}px`);
  document.documentElement.style.setProperty(
    "--visual-bottom-inset",
    `${bottomInset}px`,
  );
}

export function bindVisualViewportInsets(): () => void {
  const vv = window.visualViewport;
  if (!vv) {
    syncVisualViewportInsets();
    return unbindVisualViewportInsets;
  }

  if (!visualViewportBound) {
    onVisualViewportChange = () => syncVisualViewportInsets();
    vv.addEventListener("resize", onVisualViewportChange);
    vv.addEventListener("scroll", onVisualViewportChange);
    window.addEventListener("orientationchange", onVisualViewportChange);
    visualViewportBound = true;
  }

  syncVisualViewportInsets();
  return unbindVisualViewportInsets;
}

export function unbindVisualViewportInsets(): void {
  const vv = window.visualViewport;
  if (visualViewportBound && onVisualViewportChange) {
    vv?.removeEventListener("resize", onVisualViewportChange);
    vv?.removeEventListener("scroll", onVisualViewportChange);
    window.removeEventListener("orientationchange", onVisualViewportChange);
    visualViewportBound = false;
    onVisualViewportChange = null;
  }

  document.documentElement.style.setProperty("--visual-bottom-inset", "0px");
}
